export default "__VITE_ASSET__5fe0b984__"